export default "__VITE_ASSET__BSZehHPI__"